import React from "react";

export const Time = () => {
  return (
    <svg
      id="time"
      xmlns="http://www.w3.org/2000/svg"
      width="22.691"
      height="22.691"
      viewBox="0 0 22.691 22.691"
    >
      <g id="Group_12203" data-name="Group 12203" transform="translate(0 0)">
        <path
          id="Path_225511"
          data-name="Path 225511"
          d="M11.346,22.691A11.346,11.346,0,1,0,0,11.346,11.36,11.36,0,0,0,11.346,22.691Zm0-21.179a9.833,9.833,0,1,1-9.833,9.833,9.842,9.842,0,0,1,9.833-9.833Z"
          transform="translate(0 0)"
          fill="#2e2e2e"
        />
        <path
          id="Path_225512"
          data-name="Path 225512"
          d="M171.733,82.281a.745.745,0,0,0,.473.166.756.756,0,0,0,.473-1.346l-3.5-2.8V72.614a.756.756,0,0,0-1.513,0v6.051a.759.759,0,0,0,.284.59Z"
          transform="translate(-157.078 -67.32)"
          fill="#2e2e2e"
        />
      </g>
    </svg>
  );
};
